require('./openYoungDashboardBudgetContent.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const ComparativeCircle = require('components/commons/comparativeCircle/comparativeCircle');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilities
const currencyHelper = require('utilities/currencyHelper');

// @constants
const { EURO_SYMBOL, BY_BUDGETS } = require('constants/index');
const { getCategoryIcon } = require('constants/categories');
const { THRESHOLD_RATIO_LIMIT_BELOW_75, THRESHOLD_RATIO_LIMIT_BELOW_100 } = require('constants/comparativeCircle');

const expenseThresholds = [{
    threshold: THRESHOLD_RATIO_LIMIT_BELOW_75,
    className: 'below-seventy-five'
}, {
    threshold: THRESHOLD_RATIO_LIMIT_BELOW_100,
    className: 'below-hundred'
}];
const thresholdAboveHundredClassName = 'above-hundred';

class OpenYoungDashboardBudgetContent extends React.Component {
    constructor(props) {
        super(props);

        this.determineColorClassForExpenseBudgetRatio = this.determineColorClassForExpenseBudgetRatio.bind(this);
        this.getBudgetContent = this.getBudgetContent.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    determineColorClassForExpenseBudgetRatio(budget, expense) {
        let inputRatioBelowThresholdColorData;
        let valueToReturn;
        if (budget) {
            const expenseToBudgetRatio = expense / budget;
            inputRatioBelowThresholdColorData = expenseThresholds.find(thresholdData => expenseToBudgetRatio < thresholdData.threshold);
            valueToReturn = !inputRatioBelowThresholdColorData ? thresholdAboveHundredClassName : inputRatioBelowThresholdColorData.className;
        }
        return valueToReturn;
    }

    handleRetry() {
        const { cardInfo, getChildDetails } = this.props;
        getChildDetails(cardInfo);
    }

    generateBudgetCard(immBudgetCategory) {
        const { cardId, history } = this.props;
        const categoryName = immBudgetCategory.get('category');
        const budgetValue = immBudgetCategory.get('budget');
        let expenseValue = immBudgetCategory.get('expense');

        if (expenseValue < 0) {
            expenseValue = Math.abs(expenseValue);
        }

        const categoryIconClassName = getCategoryIcon(categoryName);
        const categroyExpenseBudgetRatioIndicator = this.determineColorClassForExpenseBudgetRatio(budgetValue, expenseValue);
        return (
            <li
                key={categoryName}
                className={`open-young-budget__category open-young-budget__category--expense-${categroyExpenseBudgetRatioIndicator}`}
                onClick={() => {
                    history.push(`/myprofile/cards/${cardId}/budgets/expenses-by-category/${categoryName}/${BY_BUDGETS}`);
                }}>
                <div className="open-young-budget__category-graph">
                    <ComparativeCircle
                        baseValue={budgetValue}
                        inputValue={expenseValue}
                    />
                    <i className={`open-young-budget__category-icon ${categoryIconClassName}`} />
                </div>
                <FormattedText
                    value={`categories-${categoryName}`}
                    className="open-young-budget__categroy-name"
                />
                <div className="open-young-budget__categroy-budget-expense-compare">
                    <span className="open-young-budget__categroy-budget-amount">
                        {currencyHelper.formatAmount(expenseValue)} {EURO_SYMBOL}
                    </span>
                    <FormattedText
                        value={"openYoungBudgets-compareOf"}
                        className="open-young-budget__categroy-budget-expense-separator"
                    />
                    <span className="open-young-budget__categroy-expense-amount">
                        {currencyHelper.formatAmount(budgetValue)} {EURO_SYMBOL}
                    </span>
                </div>
            </li>
        );
    }

    getBudgetContent(immOpenYoungDashboardChildDetails) {
        let bodyContent;

        if (immOpenYoungDashboardChildDetails.get('getChildDetailsFetch')) {
            bodyContent = <LoadingSection />;

        } else if (immOpenYoungDashboardChildDetails.get('getChildDetailsBudgetError')) {
            const lostConnectionErrorTitle = formatText('openYoungBudget-errorTitle');
            const lostConnectionErrorMessage = formatText('openYoungBudget-errorMessage');
            const retryButton = (
                <OKButton
                    className="open-young-budget__retry-button"
                    onClick={this.handleRetry}
                >
                    <FormattedText value="openYoungBudget-retry" />
                </OKButton>
            );
            bodyContent = <EmptyState primaryText={lostConnectionErrorTitle} secondaryText={lostConnectionErrorMessage} button={retryButton} iconType="nointernet-banking" />

        } else if (immOpenYoungDashboardChildDetails.get('getChildDetailsBudgetSuccess')) {
            const immBudgetCategories = immOpenYoungDashboardChildDetails.getIn(['budgetDetails', 'incomeExpense']);

            if (immBudgetCategories && immBudgetCategories.size === 0) {
                const noBudgetsMessage = formatText('openYoungBudget-noBudgetsMessage');
                bodyContent = <EmptyState primaryText={noBudgetsMessage} iconType="search-banking" />

            } else if (immBudgetCategories && immBudgetCategories.size > 0) {

                const budgetCategoryList = immBudgetCategories.reduce((list, immBudgetCategory) => {
                    if (immBudgetCategory.get('budget') > 0) {
                        list.push(this.generateBudgetCard(immBudgetCategory));
                    }
                    return list;
                }, []);

                if (budgetCategoryList.length > 0) {
                    bodyContent = (
                        <ul className="open-young-budget__categories">
                            {budgetCategoryList}
                        </ul>
                    );
                } else {
                    const noBudgetsMessage = formatText('openYoungBudget-noBudgetsMessage');
                    bodyContent = <EmptyState primaryText={noBudgetsMessage} iconType="search-banking" />
                }
            }
        } else {
            if (!immOpenYoungDashboardChildDetails.get('budgetDetails')) {
                const noBudgetErrorMessage = formatText('openYoungBudget-noBudgetErrorMessage');
                bodyContent = <EmptyState primaryText={noBudgetErrorMessage} iconType="search-banking" />
            }
        }
        return bodyContent;
    }

    render() {
        const { immOpenYoungDashboardChildDetails, cardId } = this.props;
        const budgetTitle = formatText('openYoungDashboardView-openYoungDashboardView_budgetTitle');
        return (
            <div className="open-young-dashboard-budget-content">
                <div className="open-young-dashboard-budget-content__header">
                    <OKBoxTitle
                        value={budgetTitle}
                        isNotSeparator={true}
                    />
                </div>
                <div className="open-young-dashboard-budget-content__info">
                    {this.getBudgetContent(immOpenYoungDashboardChildDetails)}
                </div>
                <div className="open-young-dashboard-budget-content__view-more-items">
                    <OKLink
                        modifier="widget"
                        inverse={true}
                        to={`/myprofile/cards/${cardId}/budgets`}
                        children={formatText('openYoungDashboardView-openYoungDashboardView_viewMoreBudgets')}
                    />
                </div>
            </div>
        );
    }
}

OpenYoungDashboardBudgetContent.propTypes = {
    cardId: PropTypes.object.isRequired,
    cardInfo: PropTypes.object.isRequired,
    getChildDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immOpenYoungDashboardChildDetails: PropTypes.object.isRequired,
};

module.exports = withRouter(OpenYoungDashboardBudgetContent);
